import { render, staticRenderFns } from "./OptionTemplate.vue?vue&type=template&id=fba450ba&scoped=true&"
import script from "./OptionTemplate.vue?vue&type=script&lang=js&"
export * from "./OptionTemplate.vue?vue&type=script&lang=js&"
import style0 from "./OptionTemplate.vue?vue&type=style&index=0&id=fba450ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba450ba",
  null
  
)

export default component.exports